import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aureus_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("aureus_token", token);
  else localStorage.removeItem("aureus_token");
}

export function getToken() {
  return localStorage.getItem("aureus_token");
}

// Build an authenticated file URL (token via query is not used; we fetch as blob for downloads)
export async function fetchFileBlobUrl(id) {
  const res = await api.get(`/documents/file?id=${id}`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}
